import { useMemo } from 'react';
import type IGameSettings from 'types/models/IGameSettings';
import { useJackpotNameByGameKey, usePremiumLinkInfo } from 'features/jackpots';

export function useEffectiveGameData(data: IGameSettings, sectionName: string) {
  const premiumLinkInfo = usePremiumLinkInfo();
  const isPremiumLinkGame = useMemo(() => premiumLinkInfo.games.includes(data.gameKey), [premiumLinkInfo]);
  const effectiveSectionName = isPremiumLinkGame ? premiumLinkInfo.sectionName || sectionName : sectionName;
  const resolvedJackpotName = useJackpotNameByGameKey(data.gameKey);

  const effectiveData = useMemo(() => {
    return !isPremiumLinkGame || !resolvedJackpotName
      ? data
      : { ...data, jackpotName: resolvedJackpotName, displayJackpotName: resolvedJackpotName };
  }, [data, sectionName, isPremiumLinkGame, resolvedJackpotName]);

  return { effectiveData, effectiveSectionName };
}
